import { DossierTypeEnum } from '@/enums/documents.enum';

export default {
    path: '/process/:id',
    component: () => import('@/views/Admin/AdminProcessView.vue'),
    meta: {
        private: true,
        breadcrumb: 'Processes',
    },
    children: [
        {
            path: 'incorporation',
            name: 'process-incorporation-details',
            component: () => import('@/components/Admin/AdminIncorporationProcess/AdminIncorporationProcess.vue'),
            meta: {
                accountTypes: ['notary', 'support', 'bookkeeper'],
                dossiers: [DossierTypeEnum.Notary, DossierTypeEnum.Client],
                defaultDossier: DossierTypeEnum.Notary,
            },
        },
        {
            path: 'share-transfer',
            name: 'process-share-transfer-details',
            component: () => import('@/features/admin/share-transfer-process'),
            meta: {
                accountTypes: ['notary', 'support'],
                dossiers: [DossierTypeEnum.Notary, DossierTypeEnum.Client],
                defaultDossier: DossierTypeEnum.Notary,
            },
        },
        {
            path: 'liquidation',
            name: 'process-liquidation-details',
            component: () => import('@/components/Admin/AdminLiquidationProcess/AdminLiquidationProcess.vue'),
            meta: {
                accountTypes: ['support', 'bookkeeper', 'notary'],
                dossiers: [DossierTypeEnum.Client],
                defaultDossier: DossierTypeEnum.Client,
            },
        },
        {
            path: 'ubo-registration',
            name: 'process-ubo-details',
            component: () => import('@/components/Admin/AdminUboProcess/AdminUboProcess.vue'),
            meta: {
                accountTypes: ['support', 'notary'],
                dossiers: [DossierTypeEnum.Notary, DossierTypeEnum.Client],
                defaultDossier: DossierTypeEnum.Notary,
            },
        },
        {
            path: 'general-flow',
            name: 'process-general-details',
            component: () => import('@/components/Admin/AdminGeneralProcess/AdminGeneralProcess.vue'),
            meta: {
                accountTypes: ['support', 'notary'],
                dossiers: [DossierTypeEnum.Provider, DossierTypeEnum.Client],
                defaultDossier: DossierTypeEnum.Client,
            },
        },
        {
            path: 'bookkeeping-offer',
            name: 'process-bookkeeping-offer-details',
            component: () => import('@/components/Admin/AdminBookkeepingOfferProcess/AdminBookkeepingOfferProcess.vue'),
            meta: {
                accountTypes: ['support', 'notary'],
                dossiers: [DossierTypeEnum.Provider, DossierTypeEnum.Client],
                defaultDossier: DossierTypeEnum.Client,
            },
        },
        {
            path: 'dga-salary-admin',
            name: 'process-dga-salary-admin-details',
            component: () => import('@/components/Admin/AdminDgaSalaryAdminProcess/AdminDgaSalaryAdminProcess.vue'),
            meta: {
                accountTypes: ['support', 'notary'],
                dossiers: [DossierTypeEnum.Provider, DossierTypeEnum.Client],
                defaultDossier: DossierTypeEnum.Client,
            },
        },
    ],
};
